import { render, staticRenderFns } from "./QuickAutoloadExpensesModal.vue?vue&type=template&id=1b589260&scoped=true"
import script from "./QuickAutoloadExpensesModal.vue?vue&type=script&lang=js"
export * from "./QuickAutoloadExpensesModal.vue?vue&type=script&lang=js"
import style0 from "./QuickAutoloadExpensesModal.vue?vue&type=style&index=0&id=1b589260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b589260",
  null
  
)

export default component.exports